import api from './api';

export const getQuizHistory = async (userId) => {
    const response = await api.get(`/api/quiz/history/${userId}`);
    return response.data;
};

export const getQuizStatus = async (userId) => {
    const response = await api.get(`/api/quiz/status/${userId}`);
    return response.data;
};

export const getDailyQuiz = async (category) => {
    const response = await api.get(`/api/quiz/daily?category=${category}`);
    return response.data;
};

export const submitQuiz = async (data) => {
    const response = await api.post('/api/quiz/submit', data);
    return response.data;
};
